export default __webpack_public_path__ + "static/media/team_lost_avatar-01.ef66a350.png";